import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async';
import Box from '@mui/material/Box';

import Show from '../utility/Show';
import { handleAddressSelection, geocodeSuggestSearch } from '../../utils/addressAutosuggest';
import { levelConfig } from '../../config/level-config';

const optionStyles = {
  control: (provided) => ({
    ...provided,
    background: '#1b3665',
    border: '1px solid #4e6488',
    maxHeight: 38,
  }),
  input: (provided) => ({
    ...provided,
    width: '100%',
    background: '#1b3665',
    color: 'white',
    zIndex: 1,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
    zIndex: 2,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#aaa',
    zIndex: 3,
  }),
  option: (provided) => ({
    ...provided,
    color: 'black',
  }),
};

const SearchBox = ({ mobile }) => {
  const [, setInputText] = useState('');
  const [inputSelection, setInputSelection] = useState(null);
  const level = useSelector(({ mainControls: { level } }) => level);
  const cacheVersion = useSelector(({ cacheVersion }) => cacheVersion);

  const handleChange = (selection) => {
    handleAddressSelection({ selection, table: levelConfig[level].table });
    setInputSelection(selection || null);
  };

  const handleLoadingOptions = async (query) => {
    const results = await geocodeSuggestSearch({ text: query, level: levelConfig[level].table, cacheVersion });
    const formattedResults = results.map((selection) => {
      if (selection.id && selection.name) return ({ label: selection.name, value: selection });
      if (selection.address && selection.magicKey) return ({ label: selection.address, value: selection });
    });
    return formattedResults;
  };

  const placeholderText = level ? `Search Address or ${level}...` : 'Search address...';

  return (
    <Box
      sx={{
        width: mobile ? '100%' : '50%',
        padding: mobile ? '0 5px 5px 5px' : 0,
        background: mobile ? '#1b3665' : '',
      }}
    >
      <Show test={!mobile}>
        <p
          style={{
            fontSize: 16,
            color: 'rgba(255, 255, 255, 0.65)',
            margin: 0,
            lineHeight: 1.4,
          }}
        >
          Search
        </p>
      </Show>
      <AsyncSelect
        loadOptions={(query) => handleLoadingOptions(query)}
        noResultsText="No results found"
        getOptionLabel={({ label }) => label}
        getOptionValue={({ value }) => value}
        onChange={handleChange}
        onInputChange={(value) => setInputText(value)}
        isClearable
        escapeClearsValue
        value={inputSelection}
        placeholder={placeholderText}
        components={{ DropdownIndicator: () => null }}
        styles={optionStyles}
        theme={(theme) => ({
          ...theme,
          paddingLeft: 40,
        })}
      />

    </Box>
  );
};

export default SearchBox;
